import CantileverCard from 'components/CantileverCard'
import React from 'react'
import styled from 'styled-components'
import { Activity } from 'types'

const ActivityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 5px;
`

const ActivityDetail = styled.div`
  padding-left: 1.25rem;
`

const ActivityNote = styled.div`
  padding-left: 0.625rem;
`

const ChangedValueSection = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding-left: 1.25rem;
  color: grey;
`

interface ActivityCardProps {
  key: string
  activityTitle: string
  activityDate: Date
  activityUser: string
  activity?: Activity[]
  note?: string
}

export const ActivityCard: React.FC<ActivityCardProps> = ({
  key,
  activityTitle,
  activityDate,
  activityUser,
  activity,
  note,
}) => {
  // Early return if there's nothing to render
  if ((!activity || activity.length === 0) && !note) {
    return undefined
  }

  return (
    <CantileverCard key={key}>
      <CantileverCard.CardHeader
        leadingContent={
          <>
            {activityTitle}
            <h5>
              {activityDate.toDateString()}{' '}
              <span style={{ color: 'grey' }}>by {activityUser}</span>
            </h5>
          </>
        }
      />
      <ActivityList>
        {note && <ActivityNote>{note}</ActivityNote>}
        {activity && activity.length > 0 && (
          <div>
            {activity.map((act) => {
              return (
                <ActivityDetail key={act.key}>
                  <div>{act.title}</div>
                  <ChangedValueSection>{act.body}</ChangedValueSection>
                </ActivityDetail>
              )
            })}
          </div>
        )}
      </ActivityList>
    </CantileverCard>
  )
}
